import RequestManager from "../../API";
import api from "../../utils/api";
import { storeFormat, storeGeneric } from "./formatActions";

export const getFormatList = (query?: string) => async (dispatch: any) => {
  const response: any = await RequestManager.getRequest(
    dispatch,
    api.GET_FORMATS,
    '',
    query
  );
  if (response) {
    const formatFilterData: any = response;
    dispatch(storeFormat(formatFilterData));
  } else {
  }
}
export const getGenericList = (query?: string) => async (dispatch: any) => {
  const response: any = await RequestManager.getRequest(
    dispatch,
    api.GET_GENERIC,
    '',
    query
  );
  if (response) {
    const formatFilterData: any = response;
    dispatch(storeGeneric(formatFilterData));
  } else {
  }
}